import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_ASSIGNED_ADMIN_QUERY from './GetAssignedAdmin.gql';

const parseResult = result => {
  const initialState = {};

  const assignedAdmin = get(result, 'core.assignedAdmin');

  return {
    ...initialState,
    ...assignedAdmin,
  };
};

export const useAssignedAdminQuery = options => {
  const [queryResult, queryAction] = useQuery(GET_ASSIGNED_ADMIN_QUERY, {
    ...options,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
